// extracted by mini-css-extract-plugin
module.exports = {"button":"az_iNb"};